<section class="bg-white w-full rounded-xl overflow-hidden">
  <app-action-sheet-header icon="mynaui:heart-home-solid" (close)="close()"
    >센터 선택</app-action-sheet-header
  >
  <app-select-center-content
    [currentCenter]="currentCenter()!"
    [centers]="props()?.items"
    (select)="selectCenter($event)"
    (navigate)="close()"
  />
</section>
